export const MODAL_TITLE = 'Processing payment';
export const MODAL_DESCRIPTION = 'Please wait while we process your payment. This may take a moment. Thank you for your patience.';
export const CANCEL_RESCHEDULE_TOUR = 'Continue Browsing';